export const USER_DATA = "useData";
export const USER_ID = "userId";
export const IS_LOGGED = "isuserlogged";
export const IS_ADMIN = "isadmin";
export const CURRENT_SERVER_URL="current_server_url"
